import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('authtoken');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && (result.error.status === 401)) {
        localStorage.removeItem('authtoken');
    }
    return result;
};

export const RequestedGym = createApi({
    reducerPath: 'RequestedGym',
    baseQuery: baseQueryWithReauth,
    tagTypes: ["Gym", "Amenity", "GymPlans", "GymPlanProfit"],
    endpoints: (builder) => ({
        getRequested: builder.query({
            query: (params) => ({
                url: `/onboard/request-gym-list`,
                params
            }),
            providesTags: ["Gym"],
        }),
        requestedDetials: builder.query({
            query: (id) => ({
                url: `/onboard/gyms-details/${id}`,
                method: "GET"
            }),
            providesTags: (result, error, id) => [{ type: "Gym", id }],
        }),
        getGymPlans: builder.query({
            query: (gymId) => ({
                url: `/onboard/gyms/${gymId}/plans/`,
                method: "GET"
            }),
            providesTags: (result, error, gymId) => [
                { type: "GymPlans", id: gymId }
            ],
        }),
        // Add the new endpoint for saving gym plan profits
        // In your API slice
        saveGymPlanProfit: builder.mutation({
            query: ({ profitDataArray, gymId,plan_ids }) => ({
                url: `/onboard/gyms/plans/profit/`,
                method: "POST",
                body: {
                    profit_data: profitDataArray,
                    gym_id: gymId,
                    plan_ids:plan_ids
                }
            }),
            invalidatesTags: ["GymPlanProfit"],
        }),
        getAllAmenities: builder.query({
            query: () => ({
                url: `/onboard/amenity`,
            }),
            providesTags: ["Amenity"],
        }),
        deleteGym: builder.mutation({
            query: (id) => ({
                url: `/onboard/gyms-details/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["Gym"],
        }),
        changeGymStatus: builder.mutation({
            query: ({ id, status, reason }) => {
                let body = { status };
                if (status === "rejected" || status === "pending") {
                    body.reason = reason;
                }
                return {
                    url: `/onboard/gyms/${id}/status/`,
                    method: "PATCH",
                    body,
                };
            },
            invalidatesTags: (result, error, { id }) => [
                { type: "Gym", id },
                "Gym",
            ],
        }),
    }),
})

export const {
    useChangeGymStatusMutation,
    useDeleteGymMutation,
    useGetAllAmenitiesQuery,
    useGetRequestedQuery,
    useRequestedDetialsQuery,
    useGetGymPlansQuery,
    useLazyGetGymPlansQuery,
    useSaveGymPlanProfitMutation
} = RequestedGym